<div class="row analytics-cards g-2">
  <div class="col-12 col-sm-6 col-xl-3 d-flex">
    <app-ticker-card
      class="clickable flex-fill"
      [titleText]="'DASHBOARD.STATISTICS.UNIQUE-LOGINS' | translate"
      [value]="dashboardStatistics.uniqueLoginsStatistics.value"
      [changePercentage]="dashboardStatistics.uniqueLoginsStatistics.changePercentage"
      icon="datatrending"
      (click)="onUniqueLoginsClick()"
    ></app-ticker-card>
  </div>

  <div class="col-12 col-sm-6 col-xl-3 d-flex">
    <app-ticker-card
      class="clickable flex-fill"
      [titleText]="'DASHBOARD.STATISTICS.NO-ACTIVITY' | translate"
      [value]="dashboardStatistics.inactiveEmployeesStatistics.value"
      [changePercentage]="dashboardStatistics.inactiveEmployeesStatistics.changePercentage"
      icon="dataarea"
      tone="info"
      (click)="onInactiveEmployeesClick()"
    ></app-ticker-card>
  </div>

  <div class="col-12 col-sm-6 col-xl-3 d-flex">
    <app-ticker-card
      class="flex-fill"
      [titleText]="'DASHBOARD.STATISTICS.CERTIFICATES' | translate"
      [value]="dashboardStatistics.completionsStatistics.value"
      [changePercentage]="dashboardStatistics.completionsStatistics.changePercentage"
      icon="datausage"
    ></app-ticker-card>
  </div>

  <div class="col-12 col-sm-6 col-xl-3 d-flex">
    <app-ticker-card
      class="flex-fill"
      [titleText]="'DASHBOARD.STATISTICS.INTERNAL-TRAININGS' | translate"
      [value]="dashboardStatistics.internalTrainingRateStatistics.value"
      [changePercentage]="dashboardStatistics.internalTrainingRateStatistics.changePercentage"
      [isPercentageValue]="true"
      icon="datapie"
      tone="info"
    ></app-ticker-card>
  </div>
</div>
